import { usePage } from '@inertiajs/react';
import { ActionIcon, Button, Group, Kbd } from '@mantine/core';
import { spotlight } from '@mantine/spotlight';
import { IconSearch } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { useMediaQuery } from '@/hooks/useMediaQuery';
import type { SharedProps } from '@/types';

const isAppleDevice = typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);
const modKey = isAppleDevice ? '⌘' : 'Ctrl';

export default function SpotlightSearchButton() {
  const { t } = useTranslation();
  const { isMobile } = useMediaQuery();
  const { current_account: currentAccount } = usePage<SharedProps>().props;

  if (!currentAccount) throw new Error('Current account not found');

  if (!currentAccount.is_pro && !currentAccount.is_super_admin) return null;

  if (isMobile) {
    return (
      <ActionIcon
        variant='default'
        color='gray'
        size='lg'
        onClick={spotlight.open}
        aria-label={t('spotlight.placeholder')}
      >
        <IconSearch size={20} stroke={1.5} />
      </ActionIcon>
    );
  }

  return (
    <Button
      variant='default'
      color='gray'
      onClick={spotlight.open}
      aria-label={t('spotlight.placeholder')}
      leftSection={<IconSearch size={18} stroke={1.5} />}
      style={{ flexShrink: 0 }}
    >
      <Group gap={4} wrap='nowrap'>
        <Kbd size='xs'>{modKey}</Kbd>
        <Kbd size='xs'>K</Kbd>
      </Group>
    </Button>
  );
}
